var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"hbo-logo",attrs:{"src":`${_vm.$assetsBase}images/hboLogo.png`,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }